// extracted by mini-css-extract-plugin
export default {"inputGroup":"daysToDelivery_inputGroup__H1rbk"};